import React from 'react';
import { Carousel } from 'react-bootstrap';

const BangalTourism = () => {
    return (
        <div className="roadRiderzProject">
        <h1 className="projects-Header">Bangal Tourism</h1>
        <div className="row site-details-rrz">
          <div className="col-md-6 p-3">
            <p>
              * Tourism related website, user can buy &
              remove product also implement Stripe payment Gateway system
              (Stripe).
            </p>
            <p>
              * Using technologies are ReactJS, NodeJS,MaterialUI, React Bootstrap, ExpressJS, MongoDB,
              Firebase, Heroku.
            </p>
            <p>
              * This Site has Dashboard user can book tour plan and see my booking option, also user can remove booking. user pay with stripe gateway in pay option and review Bangal Tourism in Review option.
            </p>
            <p>* This Site fully Functional and responsive for large device.</p>
            <p>
              * This Site has Authentication system like google signin, register
              for new user with firebase.
            </p>
            <p>* We Implement CRUD Operation in This project </p>
          </div>
          <div className="col-md-6 p-3">
            <Carousel fade>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/CnVD5Dy/Screenshot-108-1.png"
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/QQF0YBb/Screenshot-112-1.png"
                  alt="Second slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/c69L9P5/Screenshot-110-1.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/gTkN5Ns/Screenshot-113-1.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
       <div className="siteInfo">
       <h3 className="seeLive">See Live: </h3>
        <span >
          {" "}
          <a className="liveSite" target="_blank" href="https://bangal-tourism.web.app/"><b>LiveSite</b></a>
        </span>
        <span >
          <a className="clientSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/BangalTourism-team-work"><b>ClientSideCode</b></a>
        </span>
        <span>
          <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/BangalTourism-server"><b>ServerSideCode</b></a>
        </span>
       </div>
      </div>
    );
};

export default BangalTourism;